import { useQuery } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { useGetCurrentBoardId } from 'entities/user/api/hooks';
import { getCompanyGroups } from '../requests';
import type { Group } from '../types';

export const useGetCompanyGroups = (options?: {
  onSuccess: (data: Group[]) => void;
}) => {
  const boardId = useGetCurrentBoardId()!;
  return useQuery({
    queryKey: [API_QUERY_KEYS.companyGroups],
    queryFn: () => getCompanyGroups({ pathParams: { boardId } }),
    enabled: !!boardId,
    ...options,
  });
};
